import script from "./CustomerInfos.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerInfos.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerInfos.vue?vue&type=style&index=0&id=447e6e0c&scoped=true&lang=scss"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-447e6e0c"]])

export default __exports__